import { render } from "./AddCourse.vue?vue&type=template&id=a0a2a546&scoped=true"
import script from "./AddCourse.vue?vue&type=script&lang=js"
export * from "./AddCourse.vue?vue&type=script&lang=js"

import "./AddCourse.vue?vue&type=style&index=0&id=a0a2a546&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a0a2a546"

export default script